export const CATEGORIES = ["All", "Tees", "Hoodies", "Headwear", "Posters", "Accessories"];

export const PRODUCTS = [
  {
    id: 1,
    name: "Heavyweight Tour Tee",
    category: "Tees",
    spec: "240gsm Heavy Cotton",
    technique: "Screenprint / DTG",
    moq: "MOQ 25",
    img: "https://images.unsplash.com/photo-1585940220991-3ee52f287bde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxyb2NrJTIwYmFuZCUyMHQtc2hpcnQlMjBhcHBhcmVsJTIwbWVyY2glMjBtb2NrdXB8ZW58MHx8fHwxNzg5MDY1MDU5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 2,
    name: "Vintage Wash Band Tee",
    category: "Tees",
    spec: "Comfort Colors Garment Dye",
    technique: "Screenprint",
    moq: "MOQ 25",
    img: "https://images.unsplash.com/photo-1586583903558-bf4ae02b9f29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHxfHxyb2NrJTIwYmFuZCUyMHQtc2hpcnR8ZW58MHx8fHwxNzg5MDY1MDU5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 3,
    name: "Oversized Graphic Tee",
    category: "Tees",
    spec: "Boxy Fit Drop Shoulder",
    technique: "DTG / Puff Print",
    moq: "MOQ 25",
    img: "https://images.unsplash.com/photo-1596033389783-d31ed0c54440?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxyb2NrJTIwYmFuZCUyMHQtc2hpcnQlMjBhcHBhcmVsJTIwbWVyY2glMjBtb2NrdXB8ZW58MHx8fHwxNzg5MDY1MDU5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 4,
    name: "Pullover Tour Hoodie",
    category: "Hoodies",
    spec: "Independent Trading 450gsm",
    technique: "Screenprint / Embroidery",
    moq: "MOQ 20",
    img: "https://images.unsplash.com/photo-1680292783974-a9a336c10366?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxibGFjayUyMGhvb2RpZSUyMG1lcmNoJTIwbW9ja3VwJTIwbWluaW1hbGlzdHxlbnwwfHx8fDE3ODkwNjUwNjd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 5,
    name: "Zip-Up Roadie Hoodie",
    category: "Hoodies",
    spec: "Heavy Fleece, Metal Zip",
    technique: "Embroidery / Screenprint",
    moq: "MOQ 20",
    img: "https://images.unsplash.com/photo-1610582144787-eda2e6f293b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxibGFjayUyMGhvb2RpZSUyMG1lcmNoJTIwbW9ja3VwJTIwbWluaW1hbGlzdHxlbnwwfHx8fDE3ODkwNjUwNjd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 6,
    name: "Embroidered Dad Cap",
    category: "Headwear",
    spec: "Unstructured 6-Panel",
    technique: "3D Embroidery",
    moq: "MOQ 24",
    img: "https://images.unsplash.com/photo-1691256676359-20e5c6d4bc92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxzdHJlZXR3ZWFyJTIwY2FwJTIwaGF0JTIwYXBwYXJlbCUyMG1vY2t1cHxlbnwwfHx8fDE3ODkwNjUwNjd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 7,
    name: "Tour Beanie / Snapback",
    category: "Headwear",
    spec: "Ribbed Knit / Flat Brim",
    technique: "Woven Patch / Embroidery",
    moq: "MOQ 24",
    img: "https://images.unsplash.com/photo-1523380744952-b7e00e6e2ffa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxzdHJlZXR3ZWFyJTIwY2FwJTIwaGF0JTIwYXBwYXJlbCUyMG1vY2t1cHxlbnwwfHx8fDE3ODkwNjUwNjd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 8,
    name: "Silkscreened Tour Poster",
    category: "Posters",
    spec: "A2 / 18x24 Heavy Stock",
    technique: "Silkscreen / Offset",
    moq: "MOQ 50",
    img: "https://images.unsplash.com/photo-1769001800010-d8a06d716c6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxjb25jZXJ0JTIwcG9zdGVyJTIwYXJ0JTIwYWVzdGhldGljJTIwcm9jayUyMGJhbmR8ZW58MHx8fHwxNzg5MDY1MDU5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 9,
    name: "Graphic Canvas Tote",
    category: "Accessories",
    spec: "12oz Heavy Canvas",
    technique: "Screenprint",
    moq: "MOQ 50",
    img: "https://images.unsplash.com/photo-1575426553509-3c6953fdf9b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHx0b3RlJTIwYmFnJTIwZ3JhcGhpYyUyMHByaW50JTIwYWVzdGhldGljfGVufDB8fHx8MTc4OTA2NTA2N3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMG = "https://images.unsplash.com/photo-1566150951155-4a59643d8a9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxjb25jZXJ0JTIwcG9zdGVyJTIwYXJ0JTIwYWVzdGhldGljJTIwcm9jayUyMGJhbmR8ZW58MHx8fHwxNzg5MDY1MDU5fDA&ixlib=rb-4.1.0&q=85";
